import { render } from "./MobileHeaderComponent.vue?vue&type=template&id=e48f9d72&scoped=true"
import script from "./MobileHeaderComponent.vue?vue&type=script&lang=js"
export * from "./MobileHeaderComponent.vue?vue&type=script&lang=js"

import "./MobileHeaderComponent.vue?vue&type=style&index=0&id=e48f9d72&scoped=true&lang=css"

import exportComponent from "/home/u1042/tmp/bet-clipcut-003-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e48f9d72"]])

export default __exports__